import { useMutation, useQueryClient } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { useCurrentOrganisationStore } from '@/modules/core/store';
import { Plan, PriorPlanYear } from '@/modules/plan/plan.types';
import { FIRST_PLAN_YEAR_KEY } from '@/modules/plan/PlanSetup/PlanSetup.constants';
import { QUERY_KEY } from '@/modules/plan/PlanYearForm/queries/usePlanYears.query';

interface Payload {
  name: string;
  validFrom: string;
  validTo?: string;
  payoutDefinitionId?: number;
  copayGroup?: string | null;
  priorPlanYearId?: string;
  priorPlanYear?: PriorPlanYear;
}

// mock.onPost(API_URL.PLAN_YEARS_BY_ID()).reply(503);
export const useCreateHealthPlanYearQuery = (preventReset?: boolean) => {
  const { organizationId } = useCurrentOrganisationStore();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (data: Payload) => {
      const copayId = _.toNumber(data.copayGroup);
      return api.post<Plan>(API_URL.PLAN_YEARS, {
        organization_id: organizationId ? +organizationId : null,
        name: data.name,
        valid_from: data.validFrom,
        ...(data.validTo ? { valid_to: data.validTo } : {}),
        copay_group_id: copayId && !_.isNaN(copayId) ? copayId : null,
        payout_definition_id: _.toNumber(data.payoutDefinitionId),
        prior_plan_year_id:
          data.priorPlanYearId && data.priorPlanYearId !== FIRST_PLAN_YEAR_KEY
            ? _.toNumber(data.priorPlanYearId)
            : undefined,
        is_first_plan_year:
          data.priorPlanYearId === FIRST_PLAN_YEAR_KEY ? true : data.priorPlanYearId ? false : undefined,
      });
    },
    {
      onSuccess: () => {
        if (!preventReset) {
          queryClient.invalidateQueries({
            queryKey: [QUERY_KEY],
          });
        }
      },
    }
  );
  return mutation.mutateAsync;
};

export default useCreateHealthPlanYearQuery;
